<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">BC省企业家移民试点</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>2019年初，BC省（不列颠哥伦比亚省）推出了新的企业家移民试点计划，试点计划要求移民申请人必须投资于试点区域，并且至少雇佣一名全职的加拿大公民或者永久居民。试点区域人口低于75000人，且远离人口聚集的城市中心。
      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1.	家庭净资产：最少持有30万加币并能合法解释来源；</p>
            <p>2.	投资金额：至少10万加币；</p>
            <p>3. 语言： CLB4及以上（CLB 4相当于雅思： 听4.5 说4.0 阅读3.5 写作4.0）</p>
            <p>4.学历：大专以上（若申请人最近5年持股100%超过3年，则免除学历要求）</p>
            <p>5. 管理经验：最近5年至少3年以上企业股东（持股10%以上）经验；或4年以上企业高管经验；或1年企业主经验+2年高管经验</p>
            <p>6. 社区考察：完成社区考察，获得社区推荐信，撰写商业计划书</p>
            <p>7. 创业要求：创业方向与申请人背景相符，且符合社区优先推荐的行业；在加拿大指定社区完成1年创业，并投资不少于10万加币新建企业；持股要求不低于51%；至少雇佣1位加拿大公民或居民作为全职员工；</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、史上要求最低</p>
            <p>2、全家移民仅需10万加币</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/6.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、免费咨询、签约</p>
            <p>2、	前往BC省社区进行商务考察，会见社区经济官员沟通申请人创业计划，</p>
            <p>3、	考察结束后，若社区认可申请人的创业计划将发出社区推荐信(有效期90天)</p>
            <p>4、	凭社区推荐信以及CLB4语言成绩到BCPNP在线注册申请人信息、获得分数、接受筛选</p>
            <p>5、	收到邀请函的申请人准备申请文件以及商业计划并递交移民局（4个月内）</p>
            <p>6、	文件审核通过后，到温哥华BCPNP移民办事处进行面试；</p>
            <p>7、	面试通过后，BCPNP移民办事处发出工作签证支持信；</p>
            <p>8、	向加拿大联邦移民部递交工作签证申请，获批工作签证(有效期为24个月)；</p>
            <p>9、	登陆加拿大BC省，履行商业计划；</p>
            <p>10、	完成商业计划，通过BCPNP移民办事处审核，获批取省提名信；</p>
            <p>11、	递交文件到联邦移民局申请永久居民；</p>
            <p>12、	联邦移民局对申请人进行安全检查以及健康检查；</p>
            <p>13、	获得移民签证，登陆加拿大成为永居居民；</p>

          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'CaBc'
  }
</script>

<style scoped>

</style>
